export enum Features {
  LearningPaths = 'learning_paths',
  Idp = 'idp',
  Subsidies = 'subsidies',
  ZoomLms = 'zoom_lms', // deprecated
  DependentsIncluded = 'dependents_included',
  Einstein = 'einstein_cobrand',
  FullIncluded = 'full_included',
  Demo = 'demo',
  UnibradPos = 'unibrad_pos',
  DailyInsight = 'daily_insight',
  AcademicSituation = 'academic_situation',
}

export interface Feature {
  id: number;
  name: Features;
}

export interface Plan {
  code: string;
  name: string;
  features: Feature[];
  learning_paths: { accessable_paths: boolean }; // FIXME
  subsidies_eligibility: {
    eligible_assessor: boolean;
    eligible_for_subsidies: boolean;
  };
  zoom_config: { id: number; label: string }; // FIXME
}
